import { v4 } from 'uuid';

export function createId() {
    return v4();
}
